module.exports = {"id":true,"name":true,"storeCode":true,"status":true,"pickupLocation":true,"platformAssociated":{"id":true,"address":true}}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/filters/stores.json
// module id = HCgT
// module chunks = 1